import React from 'react'
import { ScaleLogarithmic, ScaleLinear } from 'd3-scale'
export const YTicks = ({
  ticks,
  x,
  scale,
  textAnchor = 'start',
  className = 'yTicks',
  textX,
  textY = (t, ticks) => scale(t),
  textT = (t, ticks) => t
}: {
  ticks: number[]
  x: [number, number]
  scale: ScaleLogarithmic<number, number>
  textAnchor?: 'start' | 'end' | 'middle'
  className?: string
  textX?: (t: number, ticks: number[]) => string | number
  textY?: (t: number, ticks: number[]) => string | number
  textT?: (t: number, ticks: number[]) => string | number
}) => {
  return (
    <g className={className}>
      {ticks.map((t, i) => {
        return (
          <React.Fragment key={i}>
            <line
              x1={x[0]}
              x2={x[1]}
              y1={scale(t)}
              y2={scale(t)}
              className={'tickLine' + (i === 0 ? ' base' : '')}
            />

            <text
              x={textX ? textX(t, ticks) : x[0]}
              y={textY(t, ticks)}
              className='tickLabel'
              textAnchor={textAnchor}
            >
              {textT(t, ticks)}
            </text>
          </React.Fragment>
        )
      })}
    </g>
  )
}
export const XTicks = ({
  ticks,
  y,
  scale,
  textAnchor = 'start',
  className = 'xTicks',
  textX = (t, ticks) => scale(t),
  textY = (t, ticks) => y[1],
  textT = (t, ticks) => t
}: {
  ticks: number[]
  y: [number, number]
  scale: ScaleLinear<number, number>
  textAnchor?: 'start' | 'end' | 'middle'
  className?: string
  textX?: (t: number, ticks: number[]) => string | number
  textY?: (t: number, ticks: number[]) => string | number
  textT?: (t: number, ticks: number[]) => string | number
}) => {
  return (
    <g className={className}>
      {ticks.map((t, i) => {
        return (
          <React.Fragment key={i}>
            <line
              y1={y[0]}
              y2={y[1]}
              x1={scale(t)}
              x2={scale(t)}
              className='tickLine'
            />
            <text
              x={textX(t, ticks)}
              y={textY(t, ticks)}
              className='tickLabel'
              textAnchor={textAnchor}
            >
              {textT(t, ticks)}
            </text>
          </React.Fragment>
        )
      })}
    </g>
  )
}
